import transFileAdminBundle from '../../../translations/AdivareAdminBundle.nl.yaml';
import transFileAdminBundleValidator from '../../../translations/validators.nl.yaml';
import transFileMessages from '../../../translations/messages.nl.yaml';

function replaceAt(message, index, replacement) {
  return message.substr(0, index) + replacement + message.substr(index + replacement.length);
}

function formatMessage(messages) {
  Object.keys(messages).forEach((key) => {
    const message = messages[key];
    if ('object' === typeof (message)) {
      messages[key] = formatMessage(message);
    } else if (-1 !== message.search('(\\%)(\\S+?\\S)(\\%)')) {
      messages[key] = replaceAt(messages[key], message.search('(\\%)(\\S+?\\S)(\\%)'), '{').replace('%', '}');
    }
  });
  return messages;
}

export default {
  nl: {
    messages_nl: formatMessage(transFileMessages),
    AdivareAdminBundle_nl: formatMessage(transFileAdminBundle),
    AdivareAdminBundleValidator_nl: formatMessage(transFileAdminBundleValidator),
  },
  'nl-NL': {
    messages_nl: formatMessage(transFileMessages),
    AdivareAdminBundle_nl: formatMessage(transFileAdminBundle),
    AdivareAdminBundleValidator_nl: formatMessage(transFileAdminBundleValidator),
  },
  en: {
    messages_nl: formatMessage(transFileMessages),
    AdivareAdminBundle_nl: formatMessage(transFileAdminBundle),
    AdivareAdminBundleValidator_nl: formatMessage(transFileAdminBundleValidator),
  },
  'en-US': {
    messages_nl: formatMessage(transFileMessages),
    AdivareAdminBundle_nl: formatMessage(transFileAdminBundle),
    AdivareAdminBundleValidator_nl: formatMessage(transFileAdminBundleValidator),
  },
};
